import React, { useState,useRef } from 'react'
import './accordion.scss'
import Image from '../Image'

const Accordion = ({options=[],defaultValue}) => {
    const contentBlock = useRef()
    let [active, setActive] = useState(defaultValue?defaultValue:{})

    return (
        <div className="accordion">
        {
            options.length >0 && options.map(option=>(
                <div className={`accordion-item ${active[option.id]?'active':''}`} key={option.id}
                onClick={()=>{
                    let obj={...active}
                    if(active[option.id]) {
                        delete obj[option.id]
                    }else{
                        obj[option.id] = option
                    }
                    setActive(obj)
                }}
                >
                <button className="accordion-header">
                    <p>{option.name}</p>
                    <Image src={`/images/icons/chevron_${active[option.id]?'up':'down'}.svg`} />
                
                </button>
                <div className={"accordion-content"} ref={contentBlock}>
                    <div>{option.description}</div>
                </div>
            </div>
            ))
        }
        </div>
    )
}

export default Accordion